import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(headerStyles, {
    ...headerStyles,
    titleGridItem: {
        width: 0,
        css: css`
            @media print {
                & {
                    display: none;
                }
            }
        `,
    },
    headerGridContainer: {
        offsetCss: css`
            justify-content: flex-end;
        `,
    },
    addToListButton: {
        css: css`
            display: none;
        `,
    },
    continueButton: {
        css: css`
            margin-left: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css`
                            width: 100%;
                            margin-left: 0;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    printButton: {
        css: css`
            background-color: #999;
            border: none;
            :hover {
                background-color: #999;
                opacity: 0.9;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    buttonsHiddenContainer: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css`
                            width: 100%;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    menuHiddenContainer: {
        css: css`
            display: none;
        `,
    },
    buttonGridItem: {
        css: css`
            justify-content: flex-end;
        `,
        width: [12, 12, 6, 6, 6],
    },
});
